import {
  Component,
  ComponentRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
  inject
} from '@angular/core';
import { IgxDialogComponent } from '@infragistics/igniteui-angular/dialog';
import { IgxButtonDirective, IgxIconButtonDirective, IgxRippleDirective } from '@infragistics/igniteui-angular/directives';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IGX_NAVBAR_DIRECTIVES, IgxNavbarModule } from '@infragistics/igniteui-angular/navbar';
import {ClsObjGenerico} from '../../../../clases-pu/util/cls-obj-generico';
import {AppPresupuestosService} from '../../../../core/services/app-presupuestos.service';
import {TranslateModule} from '@ngx-translate/core';
import {INeodataBtnsFooter} from "../../../../core/models/interfaces/generico-interface";
import {AppInfoService} from "../../../../core/services/app-info.service";
import {GenericoService} from "../../../../core/services/generico.service";

@Component({
  selector: 'app-vtn-generica',
  templateUrl: './vtn-generica.component.html',
  styleUrls: ['./vtn-generica.component.scss'],
  imports: [
    IgxIconComponent,
    IgxButtonDirective,
    TranslateModule,
    IgxDialogComponent,
    IgxIconButtonDirective,
    IgxNavbarModule,
    IGX_NAVBAR_DIRECTIVES,
    IgxRippleDirective
  ]
})
export class VtnGenericaComponent implements OnInit, OnDestroy {
  private infPpto = inject(AppPresupuestosService);
  private infApp = inject(AppInfoService);
  private servicioGen = inject(GenericoService);

  @ViewChild('vtnGenerico', {static: true})
  public vtnGenerico: IgxDialogComponent;

  @ViewChild('componente', {read: ViewContainerRef, static: true})
  public viewComponente: ViewContainerRef;

  @Input()
  public cerrarEnExteriorSeleccionar = false;
  @Input()
  public cerrarEnEscape = false;
  @Input()
  public verIconoCerrar = true;
  @Input()
  public verIconoMaxMin = false;
  @Input()
  public pantallaCompleta = false;
  @Input()
  public queVtnEstaAbierta: string;
  @Input()
  public vtnEstatica = true;
  @Input()
  public verExportar = false;
  @Input()
  public regresarEventoCerrar = false;
  @Input()
  public btnsAccion: INeodataBtnsFooter[] = [];

  @Output()
  public evtExportar: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public evtCerrarVnt: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public evtBoton: EventEmitter<INeodataBtnsFooter> = new EventEmitter<INeodataBtnsFooter>();

  public titulo: string;
  public icono = '';
  private alto = 400;
  private ancho = 400;
  // maximizar y minimizar
  public textFullScreen: string;
  public textToolTip: string;
  public altoTem: number;
  public anchoTem: number;
  public urlPdf = '';
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  // array de componentes, si existe el componente obtener la instancia y si no crearlo
  private arrayComponentes: any[] = [];

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    // this.viewComponente.clear();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    // const alto = window.innerHeight;
    // const ancho = window.innerWidth;
    if (this.verIconoMaxMin) {
      this.calcularTamanio();
    }
    // || (this.altoTem < alto && this.anchoTem < ancho)
  }

  public crearComponente(newComponent: any): any {
    this.validarComponente(newComponent);
    const componente: ComponentRef<any> = this.viewComponente.createComponent(newComponent);
    this.arrayComponentes.push(componente);
    componente.instance.vtnGenerico = this;

    return componente.instance;
  }

  private validarComponente(componente: any) {
    if (this.viewComponente.length < 1) {
      return;
    }

    const component: ComponentRef<any> = this.arrayComponentes.find((c: {
      instance: any
    }) => c.instance instanceof componente);
    let componentIndex: number = this.arrayComponentes.indexOf(component);
    if (componentIndex !== -1) {
      this.arrayComponentes.splice(componentIndex, 1);
      componentIndex = this.viewComponente.indexOf(component.hostView);
      if (componentIndex !== -1) {
        this.viewComponente.remove(componentIndex);
      }
    }
  }

  public open(alto: number, ancho: number, titulo: string, icono: string) {
    this.alto = alto;
    this.ancho = ancho;
    this.titulo = titulo;
    this.icono = icono;
    this.calcularTamanio();
    const shortcut = this.infPpto.shortcut.find(value => value.Ventana === this.queVtnEstaAbierta);
    if (shortcut) {
      shortcut.Abierto = true;
    }
    this.vtnGenerico.open();
  }

  private calcularTamanio() {
    if (this.pantallaCompleta) {
      this.altoTem = window.innerHeight - 55;
      this.anchoTem = window.innerWidth - 20;
      this.textFullScreen = 'close_fullscreen';
      this.textToolTip = this.mObjGenerico.getTranslationsMensajes('TOOLTIPS.CERRAR_VTN_COMPLETA');
    } else {
      if (this.vtnEstatica) {
        this.altoTem = (window.innerHeight < 700) ? (this.alto < 505) ? this.alto : 505 : this.alto;
        this.anchoTem = this.ancho;
      } else {
        this.altoTem = window.innerHeight - this.alto;
        this.anchoTem = window.innerWidth - this.ancho;
      }
      this.textFullScreen = 'fullscreen';
      this.textToolTip = this.mObjGenerico.getTranslationsMensajes('TOOLTIPS.VTN_COMPLETA');
    }
  }

  public fullscreen() {
    this.pantallaCompleta = !this.pantallaCompleta;
    this.calcularTamanio();
  }

  public close() {
    const shortcut = this.infPpto.shortcut.find(value => value.Ventana === this.queVtnEstaAbierta);
    if (shortcut) {
      shortcut.Abierto = false;
    }
    if (this.urlPdf.length > 0) {
      URL.revokeObjectURL(this.urlPdf);
    }
    this.vtnGenerico.close();
  }

  public cerrarVentana() {
    if (!this.regresarEventoCerrar) {
      this.close();
    }
    this.evtCerrarVnt.emit(true);
  }

  public eventoBtnExportar(evt: any) {
    this.evtExportar.emit(evt);
  }

  public onClickButton(evt: INeodataBtnsFooter) {
    // convertir id en mayusculas
    evt.id.toUpperCase();
    this.evtBoton.emit(evt);
  }
}
